export const LeagueViewType = {
	joined: 0,
	new: 1,
	popular: 2,
};
